import React from 'react';
import { Box, Button, Typography, useTheme } from '@mui/material';
import { Plus } from 'lucide-react';
import { StageSelector } from './StageSelector';
import { CaseStage } from '../../types';

interface TaskTemplateHeaderProps {
  stages: CaseStage[];
  selectedStage: string;
  onStageChange: (stageId: string) => void;
  onAddTemplate: () => void;
  currentStageName: string;
  isMobile: boolean;
}

export const TaskTemplateHeader: React.FC<TaskTemplateHeaderProps> = ({
  stages,
  selectedStage,
  onStageChange,
  onAddTemplate,
  currentStageName,
  isMobile,
}) => {
  // Find current stage and category
  const currentStage = stages.find(s => s.id === selectedStage);
  const currentCategory = currentStage?.category;

  // Get stages in the current category
  const currentCategoryStages = stages.filter(s => s.category === currentCategory);
  const currentStageIndex = currentCategoryStages.findIndex(s => s.id === selectedStage);

  return (
    <>
      <Box sx={{ 
        display: 'flex', 
        flexDirection: { xs: 'column', sm: 'row' },
        gap: 2, 
        mb: 3, 
        alignItems: { xs: 'stretch', sm: 'flex-start' }
      }}>
        <Box sx={{ flex: 1 }}>
          <StageSelector
            stages={stages}
            selectedStage={selectedStage}
            onStageChange={onStageChange}
            isMobile={isMobile}
          />
          {currentStage && (
            <Box sx={{ mt: 1 }}>
              <Typography 
                variant="caption" 
                color="text.secondary"
                component="div"
                sx={{ mb: 0.5 }}
              >
                Category: {currentCategory}
              </Typography>
              <Typography 
                variant="caption" 
                color="text.secondary"
                component="div"
              >
                Stage {currentStageIndex + 1} of {currentCategoryStages.length} in this category
              </Typography>
            </Box>
          )}
        </Box>
        <Box sx={{ pt: { xs: 0, sm: 1 } }}>
          <Button
            variant="contained"
            startIcon={<Plus />}
            onClick={onAddTemplate}
            fullWidth={isMobile}
          >
            Add Task Template
          </Button>
        </Box>
      </Box>

      <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 2 }}>
        Default tasks for {currentStageName}
      </Typography>
    </>
  );
};